import {of} from 'rxjs';
import {map, concatMap, flatMap, catchError} from 'rxjs/operators';
import {ofType} from 'redux-observable';

import Http from '../../http/http';
import AppSettings from '../../app.settings';
import * as AccountsActions from './accounts.actions';

export const CreateSubAccount = action$ =>
  action$.pipe(
    ofType(AccountsActions.CREATE_SUBACCOUNT),
    concatMap(action =>
      Http.post(`${AppSettings.IcebergApiUserInfoEndpoint}/accounts`, {
        name: action.payload.name,
        accessMode: 'discretionary'
      }).pipe(
        flatMap(data => {
          const id = data.href.split('/').pop();
          return of(AccountsActions.getAccount(id), AccountsActions.createSubAccountSuccess(data));
        }),
        catchError(error => of(AccountsActions.createSubAccountFail(error)))
      )
    )
  );

export const UpdateSubAccount = (action$, state$) =>
  action$.pipe(
    ofType(AccountsActions.UPDATE_SUBACCOUNT),
    concatMap(action =>
      Http.put(`${AppSettings.IcebergApiUserInfoEndpoint}/accounts/${action.payload.id}`, action.payload).pipe(
        flatMap(data =>
          of(
            AccountsActions.updateSubAccountSuccess(data),
            AccountsActions.getAccount(state$.value.accounts.viewing_account.id)
          )
        ),
        catchError(error => of(AccountsActions.updateSubAccountFail(error)))
      )
    )
  );

export const GetAccount = action$ =>
  action$.pipe(
    ofType(AccountsActions.GET_ACCOUNT),
    concatMap(action =>
      Http.get(`${AppSettings.IcebergApiUserInfoEndpoint}/accounts/${action.payload.id}`).pipe(
        map(data => AccountsActions.getAccountSuccess(data)),
        catchError(error => of(AccountsActions.getAccountFail(error)))
      )
    )
  );

export const UpdateInheritedRoles = (action$, state$) =>
  action$.pipe(
    ofType(AccountsActions.UPDATE_INHERITED_ROLES),
    concatMap(action =>
      Http.put(`${AppSettings.IcebergApiUserInfoEndpoint}/accounts/${action.payload.account.id}`, {
        ...action.payload.account,
        inheritedRoles: action.payload.roles
      }).pipe(
        flatMap(data =>
          of(
            AccountsActions.updateInheritedRolesSuccess(data),
            AccountsActions.getAccount(state$.value.accounts.viewing_account.id)
          )
        ),
        catchError(error => of(AccountsActions.updateInheritedRolesFail(error)))
      )
    )
  );

export const GetAccountRoles = action$ =>
  action$.pipe(
    ofType(AccountsActions.GET_ROLES),
    concatMap(() =>
      Http.get(`${AppSettings.BaseTugApiUrl}/roles`).pipe(
        map(data => AccountsActions.getAccountRolesSuccess(data)),
        catchError(error => of(AccountsActions.getAccountRolesFail(error)))
      )
    )
  );
